import * as React from "react";
import { useEffect, useRef } from "react";
import { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  IconButton,
  Grid,
  Stack,
  Avatar,
} from "@mui/material";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { tableRowSx } from "services/constants";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import TablePagination from "@mui/material/TablePagination";
import { showToast } from "services/utils/Status";
import "react-toastify/dist/ReactToastify.css";
import { Loader } from "components/Loader";
import { useSelector } from "react-redux";
import "./style.css";
import { themes, scrollTop, optionalAvathar } from "services/constants";
import sessionHandling from "services/utils/notificationUtils";
import { permissionHistory } from "../Headers";
import { InfoMessage } from "components/CustomComponents/CustomButton";

const Approved = ({
  setReloadApprovedData,
  reloadApprovedData,
  userId,
  startDate,
  endDate,
}) => {
  const { domain, token, userDetails, globalSearchValue, topbarCompanyId } =
    useSelector((state) => state.tokenReducer);
  const [loading, setLoading] = useState(false);
  const { departmentId } = useSelector((state) => state.userReducer);
  const [expandedRow, setExpandedRow] = React.useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [masterDataForSearch, setMasterDataForSearch] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const containerRef = useRef(null);

  const handleRowClick = (rowId) => {
    if (expandedRow === rowId) {
      setExpandedRow(null);
    } else {
      setExpandedRow(rowId);
    }
  };

  useEffect(() => {
    if (topbarCompanyId) {
      setReloadApprovedData(true);
    }
  }, [setReloadApprovedData, topbarCompanyId]);

  useEffect(() => {
    scrollTop(containerRef);
  }, [page]);

  useEffect(() => {
    const fetchApprovedData = async () => {
      setLoading(true);
      try {
        const permissionRequestApi = `${domain}permisson_request/?user_id=${userDetails.id}&approved_reject_status=Approved&department_id=${departmentId}&selected_user_id=${userId}&start_date=${startDate}&end_date=${endDate}&company_id=${topbarCompanyId}`;
        const response2 = await fetch(permissionRequestApi, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `token ${token}`,
          },
        });
        const res2 = await response2.json();
        if (response2.ok) {
          const totalData = res2;
          totalData?.sort(
            (a, b) =>
              new Date(b?.from_date.split("-").reverse().join("-")) -
              new Date(a?.from_date.split("-").reverse().join("-"))
          );
          setMasterDataForSearch([...totalData]);
          setFilteredData(totalData);
        } else {
          if (!response2.ok) {
            if (response2.status === 409) {
              sessionHandling();
            } else {
              throw new Error(res2.error);
            }
          }
        }
      } catch (error) {
        showToast("error", error.message);
      } finally {
        setLoading(false);
      }
    };
    if (reloadApprovedData && startDate && endDate) {
      fetchApprovedData();
      setReloadApprovedData(false);
    }
  }, [
    token,
    userDetails.id,
    domain,
    userDetails.type,
    reloadApprovedData,
    setReloadApprovedData,
    departmentId,
    userId,
    startDate,
    endDate,
    topbarCompanyId,
  ]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    const FilterDockets = () => {
      const cols =
        masterDataForSearch[0] && Object.keys(masterDataForSearch[0]);
      return masterDataForSearch.filter((r) =>
        cols.some((c) =>
          r[c]
            ? r[c]
                .toString()
                .toLowerCase()
                .indexOf(globalSearchValue.toString().toLowerCase()) > -1
            : null
        )
      );
    };
    setFilteredData(FilterDockets());
    setPage(0);
  }, [globalSearchValue, masterDataForSearch]);

  return loading ? (
    <Loader info="Loading..." />
  ) : (
    <React.Fragment>
      <Grid container>
        <TableContainer
          ref={containerRef}
          sx={{ width: "100%", maxHeight: 724, mt: 2, ml: 2, mr: 2 }}
        >
          <Table className="border">
            <TableHead
              sx={{
                backgroundColor: themes.primary,
                position: "sticky",
                top: -1,
                zIndex: 10,
              }}
            >
              <TableRow sx={tableRowSx}>
                {permissionHistory.map((header) => (
                  <TableCell
                    sx={{ color: themes.headLine, fontWeight: "bold" }}
                  >
                    {header.name}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>

            <TableBody>
              {filteredData?.length === 0 && !loading ? (
                <InfoMessage dataLength={masterDataForSearch} />
              ) : (
                filteredData
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((item) => (
                    <>
                      <TableRow sx={tableRowSx}>
                        {permissionHistory.map((header) => (
                          <TableCell sx={{ color: themes.headLine }}>
                            {header.key === "arrow" ? (
                              <>
                                {expandedRow === item.id ? (
                                  <IconButton
                                    onClick={() => {
                                      setExpandedRow(null);
                                    }}
                                  >
                                    <KeyboardArrowDownIcon
                                      style={{
                                        color: "black",
                                        fontWeight: "bold",
                                      }}
                                    />
                                  </IconButton>
                                ) : (
                                  <IconButton
                                    onClick={() => handleRowClick(item.id)}
                                  >
                                    <KeyboardArrowRightIcon
                                      style={{
                                        color: "black",
                                        fontWeight: "bold",
                                      }}
                                    />
                                  </IconButton>
                                )}
                              </>
                            ) : item[header.key] ? (
                              header.name === "Duration" ? (
                                <>
                                  {item.title === "Leave"
                                    ? item.business_days +
                                      `${
                                        item.business_days === 1
                                          ? "day"
                                          : "days"
                                      }`
                                    : item.total_time + " hr"}
                                </>
                              ) : header.name === "Name" ? (
                                <Stack direction="Row">
                                  <Avatar
                                    sx={{ width: 23, height: 23 }}
                                    alt={item?.username
                                      ?.charAt(0)
                                      .toUpperCase()}
                                    src={item?.image_url ?? optionalAvathar}
                                  />
                                  &nbsp;
                                  {item?.username ?? "N/A"}
                                </Stack>
                              ) : (
                                item[header.key]
                              )
                            ) : (
                              "N/A"
                            )}
                          </TableCell>
                        ))}
                      </TableRow>
                      {expandedRow === item.id && (
                        <TableRow sx={tableRowSx}>
                          <TableCell colSpan={9}>
                            <TableContainer
                              sx={{
                                marginTop: 0.5,
                                marginLeft: "auto",
                                marginRight: "auto",
                                width: "100%px",
                              }}
                              className="w-96 border rounded"
                            >
                              <Table className="border">
                                <Typography
                                  variant="body1"
                                  gutterBottom
                                  sx={{ marginLeft: 1, marginTop: 0.5 }}
                                >
                                  <strong>Description :</strong>{" "}
                                  <Typography
                                    fontSize={15}
                                    color="textSecondary"
                                    sx={{ marginLeft: 13 }}
                                  >
                                    {item.description}
                                  </Typography>
                                </Typography>
                              </Table>
                            </TableContainer>
                            <TableContainer
                              sx={{
                                marginTop: 0.5,
                                marginLeft: "auto",
                                marginRight: "auto",
                                width: "100%px",
                              }}
                              className="w-96 border rounded"
                            >
                              <Table className="border">
                                <Typography
                                  variant="body1"
                                  gutterBottom
                                  sx={{ marginLeft: 1, marginTop: 0.5 }}
                                >
                                  <strong>Reason for Rejection :</strong>{" "}
                                  <Typography
                                    fontSize={15}
                                    color="textSecondary"
                                    sx={{ marginLeft: 13 }}
                                  >
                                    {item.reason}
                                  </Typography>
                                </Typography>
                              </Table>
                            </TableContainer>
                            {item.title === "Leave" ? null : (
                              <TableContainer
                                sx={{
                                  marginTop: 0.5,
                                  marginLeft: "auto",
                                  marginRight: "auto",
                                  width: "100%px",
                                }}
                                className="w-96 border rounded"
                              >
                                <Table className="border">
                                  <Typography
                                    variant="body1"
                                    gutterBottom
                                    sx={{ marginLeft: 1, marginTop: 0.5 }}
                                  >
                                    <strong>
                                      Time Period :{" "}
                                      {item.start_time + " To " + item.end_time}
                                    </strong>
                                  </Typography>
                                </Table>
                              </TableContainer>
                            )}
                          </TableCell>
                        </TableRow>
                      )}
                    </>
                  ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>

      {filteredData.length > 25 && (
        <TablePagination
          className="custom-pagination"
          rowsPerPageOptions={[25, 50, 75, 100]}
          component="div"
          count={filteredData.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      )}
    </React.Fragment>
  );
};

export default Approved;
